import { AddressMap } from './types';

export const PulsechainAddresses: AddressMap = {
    BankXToken:           '0x3131ab2070BcB10A3211f63Dcc9812dd8621E639',
    XSDToken:             '0xf509C2d4Cbc4312653e96d91D2948E83A9700A77',
    BankXPool:            '0x83C60740a187a0827071156091d05DF7261E0aae',
    XSDPool:              '0x30216FF7cdcF9C1c4997ED96D1ef134E29848D21',
    CollateralPool:       '0x113d461b53f44BEc1e539f167eE03a3720DF08eB',
    PIDController:        '0x12BcB6bD2005F644b4A45858F05EbEA506e84de0',
    RewardManager:        '0x7e9d5e10c0703545fc2F325366b994ea8acEE8bc',
    RouterAddress:        '0x012180691f36e17eB411C2057e36a1b7F0552bCC',
    Arbitrage:            '',
    CertificateOfDeposit: '0xa4bdD6ea653B120C9cF7D541bFB896ED5555d5bA',
    BankXNFT:             '0x225D6F73B86381A7918cB7E23E2627bEBab4b048',
    NFTBonus:             '0x159307c1e8Eda8c7A9322bC31aa31Fb90766e025',
    NFTCollector:         '0xCfB66cf4a206e4e637bC2FFbE181bcb46bbAF1B5',
    XAGUSDPriceConsumer:  '0x18439dAdA73B574dD01B76cafa06aE5B9DF4e1e9'
};

// 06/11/2026 1103PDT
// XAGUSDPriceConsumer:  0x18439dAdA73B574dD01B76cafa06aE5B9DF4e1e9

// 12/31/2025 1956PST
// PID:                  0x12BcB6bD2005F644b4A45858F05EbEA506e84de0

// 11/07/2025 0812PST
// Router:               0x012180691f36e17eB411C2057e36a1b7F0552bCC

// 10/23/2025 2101PDT
// XSDToken:             0xf509C2d4Cbc4312653e96d91D2948E83A9700A77

// 10/13/2025 2007PDT
// BankXToken:           0x3131ab2070BcB10A3211f63Dcc9812dd8621E639
// XSDToken:             0x7bDF6423b1F0D9E7Eb5884402c1a2A4f31D110b7
// BankXPool:            0x83C60740a187a0827071156091d05DF7261E0aae
// XSDPool:              0x30216FF7cdcF9C1c4997ED96D1ef134E29848D21
// CollateralPool:       0x113d461b53f44BEc1e539f167eE03a3720DF08eB
// PID:                  0xF5A764F6c1c734932Ab7d4267640742000023368
// RewardManager:        0x7e9d5e10c0703545fc2F325366b994ea8acEE8bc
// Router:               0xdf015572C9F7874E9D0fD573A883223826987213
// Token Lockup Rewards: 0xa4bdD6ea653B120C9cF7D541bFB896ED5555d5bA
// BankXNFT:             0x225D6F73B86381A7918cB7E23E2627bEBab4b048
// NFTBonus:             0x159307c1e8Eda8c7A9322bC31aa31Fb90766e025
// ChainlinkPLSUSD:      0xC0f08AC8CcF19f921811B0CeD32469B7918B1D81
// ChainlinkXAGUSD:      0xD3B2DBacE40416A0200D9807FdBd93e6256AFA4C

// 9/11/2025 0738PDT
// BankX Token Address:  0x0176c02a8991d8cAfD6D514E73C26F32d0215a7b
// XSD Token Address:    0x5829543AAaD6E5aa5E5633B61BfdfC037e4f8ece
// BankXPool:            0x7D167aaa323cbD7eA5ffBD196Af298633CbD862F
// XSDPool:              0xd2AeBdAec7155976FBFfdefEB83Fe2B87785B267
// Colateral Pool:       0xeeA52F6587F788cc12d0b5a28c48e61866c076F0
// PID:                  0x41B27311dd4BC15Aa2488adD1f90dB00c4840C6D
// Reward Manager:       0x495d5Ce92Df01eB78ebDbE17167aA82BA2d3dfc9
// Router:               0xC7f6f26841d154a0821401d0E211E8Ba79A22d10
// Token Lockup Rewards: 0xa4bdD6ea653B120C9cF7D541bFB896ED5555d5bA
// BankXNFT:             0x225D6F73B86381A7918cB7E23E2627bEBab4b048
// NFTBonus:             0x159307c1e8Eda8c7A9322bC31aa31Fb90766e025
// eth/usd oracle:       0xC0f08AC8CcF19f921811B0CeD32469B7918B1D81
// ChainlinkXAGUSD:      0x18439dAdA73B574dD01B76cafa06aE5B9DF4e1e9
